module.exports = __webpack_public_path__ + "static/assets/a36baafaa06f48024a0a67c5c5e79a8d.png";